import * as React from 'react';
import Svg, {Path, SvgProps} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={24}
    height={26}
    viewBox="0 0 24 26"
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || 'rgba(45,39,246,0)'}
      d="M.18 22.01c0 2.17 1.75 3.95 3.95 3.95h15.69c2.17 0 3.95-1.75 3.95-3.95V7.15c0-2.17-1.75-3.95-3.95-3.95h-1.79V1.87c0-.65-.49-1.14-1.14-1.14-.65 0-1.14.49-1.14 1.14V3.2H7.77V1.87c0-.65-.49-1.14-1.14-1.14-.65 0-1.14.49-1.14 1.14V3.2H4.12C1.92 3.2.17 4.99.17 7.15v14.86h.01Zm19.61 1.67H4.13c-.91 0-1.67-.76-1.67-1.67v-9.57h19v9.57c0 .91-.76 1.67-1.67 1.67ZM4.13 5.48H5.5v.57c0 .65.49 1.14 1.14 1.14.65 0 1.14-.49 1.14-1.14v-.57h7.94v.57c0 .65.49 1.14 1.14 1.14.65 0 1.14-.49 1.14-1.14v-.57h1.79c.91 0 1.67.76 1.67 1.67v3h-19v-3c0-.91.76-1.67 1.67-1.67Z"
    />
  </Svg>
);
export default SvgComponent;
